import React, {Component, useState} from 'react'
import {
  Edit,
  Create,
  DisabledInput,
  TextInput,
  NumberInput,
  SimpleForm,
  EditButton,
  DeleteButton,
  ImageField,
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  ImageInput,
} from 'admin-on-rest'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem';
import SimpleTextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import BooleanInput from './components/BooleanInput';
import { Field } from 'redux-form';
import { getLanguages } from './restClient';
import { numberMinValidation, requiredWithRegexpValidation, validatePackage } from './utils/validation';
import { ImageFieldOrNull, format, fixIfEmptyArray } from './common';
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import RitualsRadioInput from './components/ritualsRadio';

export const PackageList = (props) => (
  <List {...props} sort={{ field: '_id', order: 'DESC' }} perPage={40}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <ImageField source="productIcon" sortable={false} label="Package Icon" />
      <TextField label="Product Identifier" source="productIdentifier" />
      <NumberField label="Public Questions" source="creditValue.public" />
      <NumberField label="Private Questions" source="creditValue.private" />
      <NumberField label="Calling Minutes" source="creditValue.minutes" />
      <BooleanField label="One-Time" source="oneTime" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
)

const PackageTitle = ({ record }) => {
  return <span>Package {record ? `"${record.productIdentifier}"` : ''}</span>
}

class LocalizationsHiddenInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      actual: props.actual,
    }
  }

  componentWillReceiveProps(newProps) {
    this.props.input.onChange(newProps.actual)
    this.setState({ actual: newProps.actual })
  }

  render() {
    return (
      <div>
        <input name="localizedIdentifier" value={this.state.actual} type="hidden" />
      </div>
    )
  }
}

class LocalizationsHidden extends Component{
  constructor(props) {
    super(props)

    this.state = {
      actual: this.formatActual(props.actual),
    }
  }

  formatActual(actual) {
    return actual.map(({lang, value}) => ({ language: lang, value }));
  }

  componentWillReceiveProps(newProps) {
    this.setState({ actual: this.formatActual(newProps.actual) })
  }

  validateField = (localizationArr) => {
    if (!localizationArr) {
      return;
    }
    let message = '';
    const colorArr = localizationArr.map(({ value, language }) => {
      const colorItem = { lang: language };
      if (!value.trim()) {
        if (!message) {
          message = 'You need to fill all localization fields in order to proceed and save item.'
        }
        colorItem.valueColor = this.props.errorBgndColor
      } else {
        colorItem.valueColor = this.props.defaultBgndColor
      }
      if (!language) {
        if (!message) {
          message = 'You need to fill all localization fields in order to proceed and save item.'
        }
        colorItem.langColor = this.props.errorBgndColor
      } else {
        colorItem.langColor = this.props.defaultBgndColor
      }
      return colorItem;
    });
    const hasOnlySpaces = localizationArr.some(({ value }) => value.length && !value.trim());
    if (hasOnlySpaces) {
      message += ' Value cannot contain only spaces.'
    }
    this.props.setError(message, colorArr);
    return message ? message : undefined;
  }

  render() {
    return (
      <Field
        name="localizedIdentifier"
        actual={this.state.actual}
        component={LocalizationsHiddenInput}
        validate={this.validateField}
      />
    )
  }
}

class LocalizedInput extends Component{
  constructor(props, ...rest) {
    super(props, ...rest);
    this.defaultBgndColor = '#ff000000';
    this.errorBgndColor = '#ff00004d';
    this.rawLanguagesArr = [];
    const { localizedIdentifier = [] }  = props.record;
    const localizedArr = localizedIdentifier.map(({ language, value }, index) => ({
      index,
      lang: language,
      value,
      langColor: this.defaultBgndColor,
      valueColor: this.defaultBgndColor,
    })) || []
    this.state = {
      languages: [],
      localizedArr,
      errorMessage: '',
    }
    this.increment = localizedArr.length;
  }

  getMenuItems(key) {
    const { languages } = this.state;
    let itemsArr = [...languages];
    if (key && !languages.includes(key)) {
      itemsArr.push(key)
    }
    return itemsArr.map((language) =>
      (<MenuItem value={language} primaryText={language} key={language} />)
    )
  }

  componentDidMount() {
    const { localizedArr } = this.state;
    getLanguages()
      .then((languages) => {
        this.rawLanguagesArr = languages;
        const resultArr = localizedArr.length ? languages.filter((language) => {
          const res = !localizedArr.some((langObj) => language === langObj.lang)
          return res;
        }) : languages
        this.setState({
          languages: resultArr
        })
      })
  }

  addLang = () => {
    const { localizedArr } = this.state;
    localizedArr.push({
      index: this.increment,
      lang: '',
      value: '',
      isNew: true,
      langColor: this.defaultBgndColor,
      valueColor: this.defaultBgndColor,
    })
    this.increment += 1;
    this.setState({
      localizedArr,
    })
  }

  onLangChange(langObj, e, isValue = false, value) {
    const resultingValue = e.target.innerText || e.target.value;
    const { index, lang } = langObj;
    const { localizedArr, languages } = this.state;
    let filteredLanguages = languages;
    const langElement = localizedArr.find((langObj) => langObj.index === index);

    if (isValue) {
      langElement.value = typeof resultingValue === 'string' ? resultingValue.trim() : resultingValue;
    } else {
      filteredLanguages = languages.filter((language) => language !== resultingValue);
      if (lang) {
        filteredLanguages.push(lang);
      }
      langElement.lang = resultingValue;
    }
    langElement.isNew = !(langElement.value && langElement.lang);

    this.setState({ localizedArr, languages: filteredLanguages });
  }

  onDelete(index) {
    const { localizedArr, languages } = this.state;
    const { lang } = localizedArr.find((langObj) => langObj.index === index);
    if (lang) {
      languages.push(lang);
    }
    const resultingArr = localizedArr.filter((langObj) => langObj.index !== index);
    this.setState({ localizedArr: resultingArr, languages });
  }

  getInputs(localizedArr) {
    const itemsStyle = {
      margin: '0 7px'
    }
    return localizedArr.map((langObj) => {
      const { index, lang, value, langColor, valueColor } = langObj;
      return (
        <div style={{ display: "flex", width: '100%' }} key={`${lang}-${index}`}>
          <SelectField
            value={lang}
            style={{ ...itemsStyle, minWidth: '75px', width: '105px', backgroundColor: langColor}}
            onChange={(e, value) => this.onLangChange(langObj, e, false, value)}
          >
            {this.getMenuItems(lang)}
          </SelectField>
          <SimpleTextField
            name={lang || 'empty'}
            defaultValue={value}
            style={{ ...itemsStyle, width: '100%', backgroundColor: valueColor }}
            onChange={(e, value) => this.onLangChange(langObj, e, true, value)}
          />
          <RaisedButton secondary={true} label={"Delete"} style={{ margin: 10 }} onClick={() => this.onDelete(index)} />
        </div>
      )
    })
  }

  setError = (errorString) => {
    const { errorMessage } = this.state;
    let changesOccured = false;
    const newLocalizedArr = [];
    // const newLocalizedArr = localizedArr.map((localizeItem) => {
    //   const colorItem = colorArr.find(({lang}) => localizeItem.lang === lang)
    //   if (!colorItem) {
    //     return localizeItem;
    //   }
    //   if (
    //     !changesOccured
    //     && (colorItem.langColor !== localizeItem.langColor
    //       || colorItem.valueColor !== localizeItem.valueColor)
    //   ) {
    //     changesOccured = true;
    //   }
    //   delete colorItem.lang;
    //   return {...localizeItem, ...colorItem}
    // })
    const updateObj = {};
    if (typeof errorString === 'string' && errorString !== errorMessage) {
      Object.assign(updateObj, {
        errorMessage: errorString,
      })
    }
    if (changesOccured) {
      Object.assign(updateObj, {
        localizedArr: newLocalizedArr,
      });
    }
    this.setState(updateObj);
  }

  render() {
    const { localizedArr, languages, errorMessage } = this.state;
    const isUnusedLanguagesLeft = languages.some((stateLang) =>
      !localizedArr.some(({ lang, isNew }) => stateLang === lang || isNew))
    const isShowAdd = this.rawLanguagesArr.length
      ? this.rawLanguagesArr.length !== localizedArr.length
      : languages.length

    const inputs = this.getInputs(localizedArr);

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h2>Localizations</h2>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
            {inputs}
          </div>
          <LocalizationsHidden
            actual={localizedArr}
            {...this.props}
            setError={this.setError}
            errorBgndColor={this.errorBgndColor}
            defaultBgndColor={this.defaultBgndColor}
          />
        </div>
        <div className="error-container">{errorMessage}</div>
        {isShowAdd ? (
          <div style={{ display: 'flex', width: '150px', minWidth: '125px'}}>
            <RaisedButton
              primary={true}
              style={{ margin: '10px 0'}}
              label={'Add Lang'}
              onClick={this.addLang}
              disabled={!isUnusedLanguagesLeft}
            />
          </div>
        ) : null}
      </div>
    )
  }
}

const defaultWarnMessage = 'You are about to create a multi-product package. If you continue, the price per item of a package could not be calculated accordingly.'

const WarnMessage = ({text = defaultWarnMessage}) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      color: '#f5b014',
    }}>
      <WarningIcon color={'#f5b014'} style={{marginRight: 5}} />
      {text}
    </div>
  )
}

export const PackageEdit = (props) => {
  const [showWarn, setShowWarn] = useState(false);
  const handleWarn = (values) => validatePackage(
    values,
    () => setShowWarn(true),
    () => setShowWarn(false)
  )
  return (
    <Edit title={<PackageTitle />} {...props}>
      <SimpleForm validate={handleWarn}>
        <DisabledInput source="id" />
        <ImageField source="productIcon" customProp="outer" />
        <ImageInput source="productIcon" accept="image/*" format={format} validate={fixIfEmptyArray}>
          <ImageFieldOrNull source="src" customProp="inner" />
        </ImageInput>
        <DisabledInput label="Product Identifier" source="productIdentifier" />
        <NumberInput validate={numberMinValidation} label="Public Questions" source="creditValue.public" />
        <NumberInput validate={numberMinValidation} label="Private Questions" source="creditValue.private" />
        {showWarn && <WarnMessage />}
        <NumberInput validate={numberMinValidation} label="Calling Minutes" source="creditValue.minutes" />
        <RitualsRadioInput label="Rituals" source="creditValue.rituals" {...props} />
        <BooleanInput label="In-App Purchase Android" source="inAppPurchaseAndroid" />
        <BooleanInput label="In-App Purchase iOS" source="inAppPurchaseIos" />
        <LocalizedInput {...props} />
        <h2>AdJust</h2>
        <TextInput label="iOs token" source="tracking.adjust.ios" />
        <TextInput label="Android token" source="tracking.adjust.android" />
        <BooleanInput label="One-time" source="oneTime" />
        <BooleanInput label="Featured" source="featured" />
      </SimpleForm>
    </Edit>
  )
}

export const PackageCreate = (props) => {
  const [showWarn, setShowWarn] = useState(false);
  const handleWarn = (values) => validatePackage(
    values,
    () => setShowWarn(true),
    () => setShowWarn(false)
  )
  return (
    <Create {...props}>
      <SimpleForm validate={handleWarn}>
        <ImageInput source="productIcon" accept="image/*" label="Related pictures" format={format} validate={fixIfEmptyArray}>
          <ImageField source="src" />
        </ImageInput>
        <TextInput
          label="Product Identifier"
          validate={requiredWithRegexpValidation}
          source="productIdentifier"
        />
        <NumberInput validate={numberMinValidation} label="Public Questions" source="creditValue.public" />
        <NumberInput validate={numberMinValidation} label="Private Questions" source="creditValue.private" />
        {showWarn && <WarnMessage />}
        <NumberInput label="Calling Minutes" source="creditValue.minutes" />
        <RitualsRadioInput label="Rituals" source="creditValue.rituals" {...props} />
        <BooleanInput label="In-App Purchase Android" source="inAppPurchaseAndroid" />
        <BooleanInput label="In-App Purchase iOS" source="inAppPurchaseIos" />
        <LocalizedInput {...props} />
        <h2>AdJust</h2>
        <TextInput label="iOs token" source="tracking.adjust.ios" />
        <TextInput label="Android token" source="tracking.adjust.android" />
        <BooleanInput label="One-time" source="oneTime" />
        <BooleanInput label="Featured" source="featured" />
      </SimpleForm>
    </Create>
  )
}



// WEBPACK FOOTER //
// ./src/packageTemplates.js